const Tokenizer = require("./tokenizer");

class TokenObject extends Tokenizer {
    constructor(registry) {
        super("object");
        this.registry = registry;
    }

    getToken(text, currentPosition) {
        let value = text[currentPosition++];
        if (value !== "{") {
            return [0, null];
        }
        let intermediateStartObject = 0;
        while (!(text[currentPosition] === "}" && intermediateStartObject === 0)) {
            if (text[currentPosition] === "{") {
                intermediateStartObject++;
            }
            if (text[currentPosition] === "}") {
                intermediateStartObject--;
            }
            value += text[currentPosition++];
        }
        value += text[currentPosition];
        return [value.length, {type: this.type, value: value}];
    }

    _populateRegistryValue(variableName) {
        const variableValue = this.registry.get(variableName);
        if (variableValue !== null && typeof variableValue === 'object') {
            return {isObject: true, value: JSON.stringify(variableValue)};
        }

        return variableValue;
    }

    _populateObjectString(objectString) {
        const stringLength = objectString.length;
        const getVariableName = (index) => {
            let variableName = "";
            while (index < stringLength && objectString[index] !== ")") {
                variableName += objectString[index++];
            }
            return variableName.trim();
        };

        let finalString = "";

        for (let index = 0; index < stringLength; index++) {
            if (objectString[index] === "$" && objectString[index + 1] === "(") {
                const variableName = getVariableName(index + 2);
                const registryValue = this._populateRegistryValue(variableName);
                if (registryValue.isObject) {
                    finalString = finalString.slice(0, -1);
                    finalString += registryValue.value;
                    index += (variableName.length + 3);
                } else {
                    finalString += this._populateRegistryValue(variableName);
                    index += (variableName.length + 2);
                }
            } else {
                finalString += objectString[index];
            }
        }

        return finalString;
    }

    interpolateValue(value) {
        let populatedStringValue = this._populateObjectString(value);
        populatedStringValue = populatedStringValue.replace(/'/g, '"');
        return JSON.parse(populatedStringValue);
    }

    parse(tokens, current) {
        return [current + 1,
            {
                type: 'ObjectLiteral',
                value: tokens[current].value,
                getInterpolatedValue: this.interpolateValue.bind(this, tokens[current].value),
                params: []
            }];
    }
}

module.exports = TokenObject;
